(function() {
  'use strict';
  function initBundleFix() {
    var allInputs = document.querySelectorAll('.quantity-break-input');
    if (allInputs.length === 0) return;

    var radioToOptionMap = {};
    allInputs.forEach(function(r, i) { radioToOptionMap[r.value] = String(i + 1); });

    var variantsEl = document.querySelector('.simple-variant-picker__variants-json');
    var productVariants = [];
    if (variantsEl) { try { productVariants = JSON.parse(variantsEl.textContent); } catch(e) {} }

    var variantOptions = [];
    if (productVariants.length > 0) {
      var v = productVariants[0];
      if (v.option1 !== null) variantOptions.push('option1');
      if (v.option2 !== null) variantOptions.push('option2');
      if (v.option3 !== null) variantOptions.push('option3');
    }

    function getSelectedVariants() {
      var selectedInput = document.querySelector('.quantity-break-option.selected input');
      if (!selectedInput) return [];
      var radioValue = selectedInput.value;
      var optionNum = radioToOptionMap[radioValue];
      var quantity = parseInt(radioValue);
      var selectedVariants = [];
      for (var i = 1; i <= quantity; i++) {
        var itemOptions = {};
        var hasOptions = false;
        variantOptions.forEach(function(optKey, index) {
          var sel = document.querySelector('.quantity-break-variant-select[data-quantity-option="' + optionNum + '"][data-item-index="' + i + '"][data-option-selector="' + (index + 1) + '"]');
          if (sel) { itemOptions[optKey] = sel.value; hasOptions = true; }
        });
        if (!hasOptions) continue;
        var matched = productVariants.find(function(v) {
          return variantOptions.every(function(optKey) { return v[optKey] === itemOptions[optKey]; });
        });
        if (matched) selectedVariants.push(matched.id);
      }
      return selectedVariants;
    }

    function updateButtonAndPrice(option) {
      var priceEl = option.querySelector('.quantity-break-price');
      var origPriceEl = option.querySelector('.quantity-break-original-price');
      var curPrice = priceEl ? priceEl.innerText : '';
      var curComparePrice = origPriceEl ? origPriceEl.innerText : '';
      var gbPrice = document.querySelector('.gb-price-drawer');
      if (gbPrice) { gbPrice.innerHTML = '<span class="money">' + curPrice + '</span>'; }
      var btnTextEl = document.querySelector('.shop-add-to-cart-button .button-text');
      if (btnTextEl) {
        var newText = 'ADD TO BAG - ' + curPrice;
        if (curComparePrice) { newText += ' <span class="compare-price">(' + curComparePrice + ')</span>'; }
        btnTextEl.innerHTML = newText;
      }
    }

    function addBundleToCart(variants, btn) {
      var items = variants.map(function(vid) { return { id: parseInt(vid), quantity: 1 }; });
      var spinner = btn ? btn.querySelector('.loading__spinner') : null;
      if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
      if (spinner) spinner.classList.remove('hidden');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        if (btn) { btn.classList.remove('loading'); btn.setAttribute('aria-disabled', 'false'); }
        if (spinner) spinner.classList.add('hidden');
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          fetch('/cart?view=drawer').then(function(r) { return r.text(); })
          .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            var newDrawer = doc.querySelector('#CartDrawer');
            if (newDrawer && cartDrawer.children[0]) {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.replaceChild(newDrawer, cartDrawer.children[0]);
              fetch('/cart.js').then(function(r) { return r.json(); })
              .then(function(cart) {
                var countSpan = document.querySelector('.cart-count-bubble span');
                if (countSpan) { countSpan.textContent = cart.item_count; }
                if (typeof cartDrawer.open === 'function') { cartDrawer.open(); }
              });
            }
          });
        } else { window.location.href = '/cart'; }
      })
      .catch(function() {
        if (btn) { btn.classList.remove('loading'); btn.setAttribute('aria-disabled', 'false'); }
        if (spinner) spinner.classList.add('hidden');
      });
    }

    document.querySelectorAll('.quantity-break-option').forEach(function(option) {
      option.addEventListener('click', function(e) {
        document.querySelectorAll('.quantity-break-option').forEach(function(o) { o.classList.remove('selected'); });
        this.classList.add('selected');
        var input = this.querySelector('input');
        if (input) input.checked = true;
        updateButtonAndPrice(this);
        e.stopImmediatePropagation();
      }, true);
    });

    var submitBtn = document.querySelector('.shop-add-to-cart-button');
    if (submitBtn) {
      document.addEventListener('click', function(e) {
        if (!submitBtn.contains(e.target)) return;
        var selectedInput = document.querySelector('.quantity-break-option.selected input');
        if (!selectedInput || parseInt(selectedInput.value) <= 1) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        window.quantityBreakProcessing = true;
        var variants = getSelectedVariants();
        if (variants.length === 0) { window.quantityBreakProcessing = false; return; }
        addBundleToCart(variants, submitBtn);
      }, true);
    }

    var selected = document.querySelector('.quantity-break-option.selected');
    if (selected) { updateButtonAndPrice(selected); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(initBundleFix, 100); });
  } else { setTimeout(initBundleFix, 100); }
})();
